// Business notifications to Slack (payments, signups, onboarding choices), relayed through
// the API so no Slack webhook URL ships in the bundle. Errors go to reportError instead.
const ENDPOINT = `${process.env.REACT_APP_SNUG_API_URL}/v3/client-notifications/`;

export const slackHook = async (payload: string) => {
  if (process.env.REACT_APP_SNUG_ENV === "LOCAL" || !process.env.REACT_APP_SNUG_API_URL) return;
  fetch(ENDPOINT, {
    method: "POST",
    keepalive: true,
    // text/plain keeps this a "simple" request: no CORS preflight
    headers: { "Content-Type": "text/plain" },
    body: JSON.stringify({ app: "total", message: payload }),
  }).catch(() => {});
};
